// extracted by mini-css-extract-plugin
module.exports = {"widget":"turnstile-widget_widget__ocTzy"};